"use client";

import { useMemo, useState } from 'react';
import styles from './_hcp-accordion.module.scss';
import CustomImage from '@/components/image';
import PageAnchor from '@/components/page-anchor';
import { renderToString } from 'react-dom/server';

export default function HcpAccordion({label, anchorId = undefined, children}) {
  const [stateOpen, setStateOpen] = useState(false);

  function setFound(found) {
    // console.log('found ?', anchorId, found);
    found && setStateOpen(true);
  }

  const contentClass = useMemo(() => {
    let className = styles.content;
    if (stateOpen) {
      className = `${className} ${styles.content_open}`;
    }
    return className;
  },[stateOpen]);

  function handleClick() {
    setStateOpen(!stateOpen);
  }

  return (
    <>
      {anchorId && <PageAnchor anchorId={anchorId} setFound={setFound} />}
      <section className={`${styles.container} hcp-accordion`}>
        <button
          type="button"
          onClick={handleClick}
          data-gtm-event-category="Accordion"
          data-gtm-event-action="Click"
          data-gtm-event-label={`${renderToString(label)} - ${stateOpen ? 'Close' : 'Open'}`}
        >
          <div className="container container--px-0">
            {stateOpen && <div className={styles.button_wrapper}>
              <span className={styles.label}>{label}</span>

              <CustomImage
                src="/images/icons/Collapse-Icon.svg"
                width={50}
                height={30}
                alt="Click to collapse section"
              />
            </div>}
            {!stateOpen && <div className={styles.button_wrapper}>
              <span className={styles.label}>{label}</span>

              <CustomImage
                src="/images/icons/Expand-Icon.svg"
                width={50}
                height={30}
                alt="Click to expand section"
              />
            </div>}
          </div>
        </button>
        <div className={contentClass}>
          {children}
        </div>
      </section>
    </>
  );
}